import './abstract_section_view.coffee'
Namespace('Monitoring.Reports.Executive')

class Monitoring.Reports.Executive.SentimentCompetitionView extends Monitoring.Reports.Executive.AbstractSectionView
  genericTemplate: JST["backbone/templates/monitoring/reports/executive/generic_template"]
  tagName: 'section'
  id: 'brand-sentiment-comparition'
  chartClass: 'sentiment-column-container column-chart'
  icon: 'column'

  initialize: (@options = {}) ->
    @categories = [@options.settings.accountLabel.description].concat(_.map(@options.settings.competitorsLabels, (competitor) -> competitor.description))
    @colors = @options.colors
    @PIE_HORIZONTAL_UNITS = 190 # TODO: valid size only for 5 pies...

  render: ->
    @bindChartsReady(@categories.length)
    @results = {}
    @requestsCompleted = 0
    @$el.html(@genericTemplate(self: this))
    @addBars('.chart_container')
    return this

  addBars: (divId) ->
    @$el.find(divId).addClass('processing')
    query = @_getQuery({ labels: @options.settings.accountLabel.codes })
    $.post(@options.chartApi.singleDimension, query, (response) =>
      series = @_onSuccess(response)
      @results[@options.settings.accountLabel.description] = @_getResults(series)
      _.each(@options.settings.competitorsLabels, (competitor) =>
        query = @_getQuery({ labels: competitor.codes })
        $.post(@options.chartApi.singleDimension, query, ((competitor) =>
            (response) =>
              series = @_onSuccess(response)
              @results[competitor.description] = @_getResults(series)
              if @requestsCompleted == @categories.length
                @drawChart(series, divId, (=> @_pieOptions(divId)), { highchartsFunction: @_highchartsFunction } )
          )(competitor)
        )
      )
    )

  _highchartsFunction: (chart) =>
      _.each(@categories, (category, index) =>
        chart.renderer.text(category, (@PIE_HORIZONTAL_UNITS - 5) * (index + 1), 50).css({color: '#4572A7', fontSize: '16px'}).add()
      )
      $(chart.series[0].data).each (i, e) ->
        e.legendItem.on 'click', (event) ->
          legendItem = e.name
          event.stopPropagation()
          $(chart.series).each (j, f) ->
            $(@data).each (k, z) ->
              if z.name == legendItem
                if z.visible
                  z.setVisible false
                else
                  z.setVisible true

  _getQuery: (query={}) ->
    _.extend({}, @extendedQuery(_.extend({dimension: 'sentiment'}, query)), @getExtraQuery())

  _onSuccess: (response) ->
    @requestsCompleted++
    @chartReady('.chart_container')
    series = if response.benchmark_data
            { series: response.benchmark_data }
      else if response.anual_data
            { series: response.anual_data }
      else
            response
    @_removeMissing(series)
    return series

  _getResults: (response) ->
    _.map response.series[0].data, (data) => { name: data.name, y: data.y, color: @colors[data.code], code: data.code }

  _pieOptions: (divId) =>
    series = _.map @categories, (category) =>
      index = @categories.indexOf(category)
      {
        type: 'pie'
        name: category
        showInLegend: (index == 0)
        center: [(@PIE_HORIZONTAL_UNITS) * (index + 1), null]
        size: 100
        dataLabels: { enabled: false }
        data: @results[category]
      }
    _.extend({legend: { itemMarginBottom: 10 }}, @pieOptions({series: series}, divId, { fivePies: true } ))
